const RANDOM_SEED = (Math.random() * Math.pow(2, 32) - Math.pow(2, 31)) | 0;
const A = 0x85ebca6b | 0;
const B = 0xc2b2ae35 | 0;
const C1 = 0xcc9e2d51 | 0;
const C2 = 0x1b873593 | 0;
const D = 0xe6546b64 | 0;

const imul = Math.imul || function(l, r) {
    const ll = l & 0xffff;
    const lh = (l >>> 16) | 0;
    const rl = r & 0xffff;
    const rh = (r >>> 16) | 0;
    return (((ll * rl) | 0) + ((lh * rl + rh * ll) << 16)) | 0;
};

const rotl32 = function(k, r) {
    return (k << r) | (k >>> (32 - r));
};

const fmix = function(k) {
    k = k ^ (k >>> 16);
    k = imul(k, A);
    k = k ^ (k >>> 13);
    k = imul(k, B);
    k = k ^ (k >>> 16);
    return k;
};

export default function murmur3(string, seed) {
    let hash = (seed === void 0 ? RANDOM_SEED : seed) | 0;
    const stringLength = string.length;

    let k = 0;
    let i, len;
    for (i = 0, len = stringLength - 1; i < len; i += 2) {
        k = (string.charCodeAt(i) << 16) | string.charCodeAt(i + 1);
        k = imul(k, C1);
        k = rotl32(k, 15);
        k = imul(k, C2);

        hash = hash ^ k;
        hash = rotl32(hash, 13);
        hash = (imul(hash, 5) + (D | 0)) | 0;
    }

    if (i < stringLength) {
        k = string.charCodeAt(i);
        k = (k >>> 8) | ((k & 0xff) << 8);

        k = imul(k, C1);
        k = rotl32(k, 15);
        k = imul(k, C2);

        hash = hash ^ k;
    }

    hash = hash ^ stringLength;
    return fmix(hash);
}


// WEBPACK FOOTER //
// ./src/abusesa-js/hash/murmur3.js